import { Link } from "react-router-dom";

export default function CompetitionCard({ competition }) {
  const {
    name,
    id,
    competition_events
  } = competition;

  return (
    <Link to={`/admin/competitions/${id}`}>
      <div className="w-full border-t border-gray-200 py-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col">
            <span className="font-medium text-lg">{name}</span>
            <span className="text-sm text-gray-500">
              Events: {competition_events.length}
            </span>
          </div>

          <div className="flex items-center gap-2 mt-2 md:mt-0">
            <p className="text-sm underline">Competition Overview</p>
          </div>
        </div>
      </div>
    </Link>
  );
}
